import React from 'react';
import { CopyIcon } from 'components/common/icons';
import { ContactInfoFieldKeyType } from 'typings/form';
import { Button, Col, Row, Typography } from 'components';
import { CopiedIcon } from 'components/common/icons/contactFieldManagerIcons/CopiedIcon';
import { CONTACT_TYPES_MAPPING } from 'components/common/ContactFieldManager/ContactInfoCard';
import { useContactFieldRow } from './useContactFieldRow';

const { Text } = Typography;

interface IContactFieldRow {
  data: string[];
  type: ContactInfoFieldKeyType;
  fieldValueMaxWidth?: number;
}

export const ContactFieldRow = React.memo((props: IContactFieldRow) => {
  const { data, type, fieldValueMaxWidth } = props;
  const { onCopy, copyStatus } = useContactFieldRow();
  return (
    <Col span={24} key={type}>
      <Row justify={'space-between'} align={'middle'} style={{ height: '24px' }}>
        <Col>
          <Row gutter={4} align={'middle'}>
            {CONTACT_TYPES_MAPPING[type as ContactInfoFieldKeyType].icon}
            <Col>
              <Text style={{ color: '#525866' }}>{CONTACT_TYPES_MAPPING[type as ContactInfoFieldKeyType].value}</Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row gutter={4} justify={'end'} align={'middle'}>
            <Col span={24}>
              <Row gutter={4} align={'middle'}>
                <Col>
                  <Text style={{ maxWidth: fieldValueMaxWidth || undefined }} ellipsis={{ tooltip: true }}>
                    {data[0]}
                  </Text>
                </Col>
                <Col>
                  <Row>
                    <Button
                      size={'small'}
                      type={'link'}
                      variant={'link'}
                      onClick={() => onCopy(data[0])}
                      icon={copyStatus[data[0]] ? <CopiedIcon /> : <CopyIcon />}
                    ></Button>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {data.slice(1).map((value, index) => (
        <Row key={`${type}-${index}`} gutter={4} justify={'end'} align={'middle'} style={{ height: '24px' }}>
          <Col>
            <Row gutter={4} align={'middle'}>
              <Col>
                <Text style={{ maxWidth: fieldValueMaxWidth || undefined }} ellipsis={{ tooltip: true }}>
                  {value}
                </Text>
              </Col>
              <Col>
                <Row>
                  <Button
                    size={'small'}
                    type={'link'}
                    variant={'link'}
                    onClick={() => onCopy(value)}
                    icon={copyStatus[value] ? <CopiedIcon /> : <CopyIcon />}
                  ></Button>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      ))}
    </Col>
  );
});
